import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from '../../config/routes'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from '../../vuex/store'
import VueResource from 'vue-resource'
import components from '../../components/' //加载公共组件
import directives from '../../directives/' //加载公共指令
import { sync } from 'vuex-router-sync'
import Wcontext from './context.js'
import '../../assets/css/base.css'
import '../../styles/common.scss';
import 'iview/dist/styles/iview.css';
import tootik from 'tootik' //引入提示框架,不用element UI的
import Wmsg from 'iview/src/components/message'; //引入全局消息提示组件
import { Loading } from 'element-ui';

Vue.use(ElementUI)
Vue.use(VueResource)
sync(store, router)

//注册公共组件
Object.keys(components).forEach((key) => {
    var name = key.replace(/(\w)/, (v) => v.toUpperCase()) //首字母大写
    // console.log('------------' + name);
    Vue.component(`ws${name}`, components[key])
})

//注册VUE全局对象
Vue.prototype.$Wmsg = Wmsg;

//注册公共指令
Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key])
})

//注册全局HTTP处理器
Vue.http.interceptors.push(function(request, next) {
  let curLoading = Loading.service({ lock: true, text: '加载中...' });
  //添加URL地址解析服务
  // console.log(request.url);
  let tokenId = store.getters.auth_tokenId;
  request.headers.set('Authorization', "Bearer " + tokenId);
  request.headers.set('w-client', "bus");
  // continue to next interceptor
  next(function(response) {
    //处理消息响应(通用错误消息处理)
    curLoading.close();
    if(response.status == 401) {
      //登录失败
      window.location.href = 'login.html';
    }
  });
});


//触发用户初始化服务
Wcontext.init();

new Vue({
  el: '#app',
  template: '<App/>',
  router,
  store,
  components: { App }
}).$mount('#app')





// WEBPACK FOOTER //
// ./src/view/index/index.js